<template>
  <div class="cart">
    <ui-title :title="t('cart.title')" :wave="'/cartTitleBg.png'" />
    <div class="cart__block">
      <div class="cart__bg"></div>
      <div class="container">
      <div class="cart__wrapper">
        <div class="cart__main">
          <div class="cart__main-top">
            <p>{{ t('cart.product') }}</p>
            <p>{{ t('cart.price') }}</p>
          </div>
          <div class="cart__main-list">
            <div class="cart__main-product" v-for="product in productsInCart" :key="product.node.product.uuid">
              <div>
                <svg @click="removeFromCart(product.node.product.uuid)" width="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.7998 6.96898C20.0838 6.60072 16.3454 6.41101 12.6181 6.41101C10.4085 6.41101 8.19898 6.52261 5.98941 6.74579L3.71289 6.96898" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.85107 5.84175L10.0966 4.37987C10.2751 3.31972 10.409 2.5274 12.295 2.5274H15.2188C17.1047 2.5274 17.2498 3.36436 17.4172 4.39103L17.6627 5.84175" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17.3387 24.8467H10.1743C7.06086 24.8467 6.96042 23.4852 6.83767 21.7332L6.1123 10.4957" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21.4011 10.4957L20.6758 21.7332" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.8926 18.7087H15.6087" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.6714 14.2448H16.5462" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.9663 14.2448H11.8925" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <router-link :to="translations.i18nRoute({ name: 'product', params: { productUuid: product.node.product.uuid } })">
                  <img class="cart__main-product-image" :src="product.node.product.images.edges[0].node.image" :alt="product.node.product.name">
                </router-link>
                <h6>{{ product.node.product.name }}</h6>
              </div>
              <p><img src="@icons/currency.svg" alt="currency"> {{ product.node.product.price }}</p>
            </div>
          </div>
          <ui-checkbox
              v-model="isAgree"
              class="cart__main-checkbox"
          >
            <p>
              {{ t('checkboxes.accept') }}
              <router-link class="link" :to="translations.i18nRoute({ name: 'terms-and-conditions' })">
                {{ t('docs.terms.title') }}
              </router-link>
              <span> & </span>
              <router-link class="link" :to="translations.i18nRoute({ name: 'privacy-policy' })">
                {{ t('docs.policy.title') }}
              </router-link>
            </p>
          </ui-checkbox>
          <div class="cart__main-checkout" v-if="productsInCart.length">
            <div>
              <p>{{ t('cart.total') }} <span><img src="@icons/currency.svg" alt="currency">{{ totalPrice }}</span></p>
            </div>
            <ui-button
                @click="buyOrder"
                class="cart__main-checkout-button"
                :isDisabled="!isAgree"
            >
              {{ t('cart.checkout') }}
              <svg width="25" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.74365 7.66964V6.69964C7.74365 4.44964 9.55365 2.23964 11.8037 2.02964C14.4837 1.76964 16.7437 3.87964 16.7437 6.50964V7.88964"
                    stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.24348 21.9998H15.2435C19.2635 21.9998 19.9835 20.3898 20.1935 18.4298L20.9435 12.4298C21.2135 9.98976 20.5135 7.99976 16.2435 7.99976H8.24348C3.97348 7.99976 3.27348 9.98976 3.54348 12.4298L4.29348 18.4298C4.50348 20.3898 5.22348 21.9998 9.24348 21.9998Z"
                    stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.7396 12H15.7486" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.73816 12H8.74714" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </ui-button>
          </div>
          <p class="wishlist__main-empty" v-else>{{ t('cart.empty') }}</p>
        </div>
        <div class="cart__like">
          <p class="cart__like-title">{{ t('cart.alsoLike') }}</p>
          <swiper
              class="cart__like-swiper"
              :modules="[Pagination]"
              :pagination="{
                clickable: true,
              }"
              :loop="true"
              :speed="500"
              :breakpoints="{
                200: {
                  slidesPerView: 1,
                  spaceBetween: 50
                }
              }"
              v-if="alsoLikeProducts"
          >
            <swiper-slide
                v-for="(productPair, index) in products"
                :key="index"
            >
              <div class="cart__like-list">
                <product-card
                    v-for="product in productPair"
                    :key="product.node.uuid"
                    :product="product.node"
                />
              </div>
            </swiper-slide>
          </swiper>
          <div class="cart__like-list" v-if="isLoading">
            <product-card-skeleton
              v-for="idx in 2"
              :key="idx"
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import UiTitle from "@/components/ui/ui-title.vue";
import {useI18n} from "vue-i18n";
import {computed, h, onMounted, ref, watch} from "vue";
import {useCartStore} from "@/stores/cart.js";
import translations from "@/core/helpers/translations.js";
import {Products} from "@/core/api/products.js";
import ProductCard from "@/components/cards/product-card.vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/pagination';
import 'swiper/css';
import {Pagination} from "swiper/modules";
import UiButton from "@/components/ui/ui-button.vue";
import ProductCardSkeleton from "@/components/skeletons/product-card-skeleton.vue";
import {Orders} from "@/core/api/orders.js";
import {ElNotification} from "element-plus";
import {useAuthStore} from "@/stores/auth.js";
import {useRouter} from "vue-router";
import {Auth} from "@/core/api/auth.js";
import UiCheckbox from "@/components/ui/ui-checkbox.vue";

const {t, locale} = useI18n()
const cartStore = useCartStore()
const authStore = useAuthStore()
const router = useRouter()

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const userBalance = computed(() => {
  return authStore.user ? authStore.user.balance.amount : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder ? cartStore.currentOrder.uuid : null
})

const userEmail = computed(() => {
  return authStore.user ? authStore.user.email : ''
})
const isAgree = ref(false)

const totalPrice = computed(() => {
  return cartStore.currentOrder?.totalPrice ? Number(cartStore.currentOrder?.totalPrice).toFixed(2) : 0
})
const productsInCart = computed(() => {
  return cartStore.currentOrder.orderProducts ? cartStore.currentOrder.orderProducts.edges : []
})

const alsoLikeProducts = ref([])
const isLoading = ref(false)
const products = computed(() => {
  if (!alsoLikeProducts.value.length) return [];

  const groupedProducts = [];
  for (let i = 0; i < alsoLikeProducts.value.length; i += 2) {
    const pair = [alsoLikeProducts.value[i]];
    if (alsoLikeProducts.value[i + 1]) {
      pair.push(alsoLikeProducts.value[i + 1]);
    }
    groupedProducts.push(pair);
  }
  return groupedProducts;
});

const removeFromCart = async (productUuid) => {
  const res = await Orders.overwriteCart("removeOrderProduct", accessToken.value, orderUuid.value, productUuid);

  cartStore.setCurrentOrders(res.data.removeOrderProduct.order)
}

const buyOrder = async () => {
  if (Math.trunc(userBalance.value) > Math.trunc(totalPrice.value)) {
    const res = await Orders.buyOrder(accessToken.value, orderUuid.value)

    if (res.errors) {
      ElNotification({
        message: res.errors[0].message,
        type: 'error'
      })
    } else {
      ElNotification({
        message: h('div', [
          h('p', t('popup.successCheckout')),
          h(
            'button',
            {
              style: {
                marginTop: '10px',
                padding: '6px 12px',
                backgroundColor: '#2B3044',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              },
              onClick: () => {
                router.push({
                  name: 'profile-orders',
                  params: {
                    locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
                  }
                })
              }
            },
            t('buttons.goOrders')
          )
        ]),
        type: 'success'
      })

      const userRes = await Auth.refresh()
      authStore.setUser({
        user: userRes.data.refreshJwtToken.user,
        accessToken: userRes.data.refreshJwtToken.accessToken
      })

      const currentOrder = await Orders.getOrders("PENDING", accessToken.value, userEmail.value)
      cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)
    }
  } else {
    ElNotification({
      message: t('popup.noBalance'),
      type: 'error'
    })
  }
}

const getProducts = async () => {
  isLoading.value = true

  const res = await Products.getProducts(`tags: "top"`)
  alsoLikeProducts.value = res.data.products.edges.slice(0, 6)

  isLoading.value = false
}

watch(
    () => locale.value,
    async () => {
      alsoLikeProducts.value = [];
      await getProducts()
    }
)

onMounted( async () => {
  await getProducts()
})
</script>

<style lang="scss" scoped>
.cart {
  top: -103px;
  background-color: $white;
  
  &__block {
    position: relative;
    padding-bottom: 50px;
  }
  
  &__bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 600px;
    background-color: #F3FAFD;
  }

  &__wrapper {
    display: flex;
    align-items: flex-start;
    gap: 150px;
    padding-top: 55px;
  }

  &__main {
    width: 100%;

    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid #5B194F;
      padding-inline: 25px;
      padding-bottom: 10px;

      & p {
        color: #696969;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
      }
    }

    &-list {
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }

    &-product {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 25px 15px;
      border-bottom: 1px solid #B1B1B1;

      & div {
        display: flex;
        align-items: center;
        gap: 25px;

        & svg {
          cursor: pointer;
        }
      }

      & h6 {
        color: #2B3044;
        font-family: Syne, sans-serif;
        font-size: 20px;
        font-weight: 700;
      }

      & p {
        display: flex;
        align-items: center;
        gap: 5px;

        color: #2B3044;
        font-size: 16px;
        font-weight: 500;

        & img {
          width: 30px;
        }
      }

      &-image {
        border-radius: 20px;
        width: 130px;
        height: 80px;
        object-fit: cover;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    &-checkout {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 25px;
      border-radius: 4px;
      background-color: #F3FAFD;

      & div {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      & p {
        display: flex;
        align-items: center;
        gap: 10px;

        color: #2B3044;
        text-align: center;
        font-size: 20px;
        font-weight: 500;

        & span {
          display: flex;
          align-items: center;
          gap: 5px;

          color: #2B3044;
          font-size: 16px;
          font-weight: 500;

          & img {
            width: 27px;
          }
        }
      }

      &-button {
        width: fit-content;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 10px 20px;
      }
    }

    &-checkbox {
      margin-block: 20px;

      & .link {
        text-decoration: underline;
      }
    }

    &-empty {
      padding-top: 20px;
      text-align: center;
      color: #2B3044;
      font-family: Syne, sans-serif;
      font-size: 20px;
      font-weight: 700;
    }
  }

  &__like {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;

    &-title {
      flex-shrink: 0;
      font-family: Syne, sans-serif;
      font-size: 20px;
      font-weight: 700;
      background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &-swiper {
      width: 400px;
      padding-inline: 10px;
      padding-bottom: 50px;
    }

    &-list {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    &-skeleton {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
}

@media (max-width: 1680px) {
  .cart__bg {
    width: 700px;
  }
}

@media (max-width: 1550px) {
  .cart__bg {
    width: 600px;
  }
}

@media (max-width: 1300px) {
  .cart__bg {
    width: 500px;
  }
}

@media (max-width: 1100px) {
  .cart {
    &__bg {
      display: none;
    }

    &__wrapper {
      flex-direction: column;
    }

    &__like {
      width: 100%;
      padding-top: 25px;
      background-color: #F3FAFD;

      &-title {
        text-align: center;
      }
    }
  }
}

@media (max-width: 550px) {
  .cart {
    &__main {
      &-product {
        &-image {
          width: 110px;
          height: 70px;
        }

        & div {
          gap: 15px;
          flex-direction: column-reverse;
          align-items: flex-start;
        }

        & h6 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>